type Listener = (online: boolean) => void;

class ConnectivityServiceClass {
    private _isOnline: boolean = navigator.onLine;
    private _listeners: Listener[] = [];
    private _healthCheckInterval: any = null;

    constructor() {
        window.addEventListener('online', () => this._setOnline(true));
        window.addEventListener('offline', () => this._setOnline(false));
    }

    get isOnline(): boolean {
        return this._isOnline;
    }

    subscribe(listener: Listener): void {
        this._listeners.push(listener);
    }

    unsubscribe(listener: Listener): void {
        this._listeners = this._listeners.filter(l => l !== listener);
    }

    startHealthCheck(apiUrl: string, intervalMs: number = 30000): void {
        if (this._healthCheckInterval) return;
        this._healthCheckInterval = setInterval(async () => {
            try {
                const res = await fetch(`${apiUrl}/authentication/status`, {
                    method: 'GET',
                    credentials: 'include',
                    signal: AbortSignal.timeout(5000),
                });
                this._setOnline(res.ok || res.status === 401);
            } catch {
                this._setOnline(false);
            }
        }, intervalMs);
    }

    stopHealthCheck(): void {
        if (this._healthCheckInterval) {
            clearInterval(this._healthCheckInterval);
            this._healthCheckInterval = null;
        }
    }

    private _setOnline(online: boolean): void {
        const changed = this._isOnline !== online;
        this._isOnline = online;
        if (changed) {
            console.log(`[Connectivity] ${online ? 'ONLINE' : 'OFFLINE'}`);
            this._listeners.forEach(l => l(online));
        }
    }
}

export const ConnectivityService = new ConnectivityServiceClass();
export default ConnectivityService;
